import React from 'react'

import { Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'
import PlaceLevelInputs from './placeLevels/PlaceLevelInputs'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const LevelsSection = () => {
  return (
    <>
      <Grid paddingGutter={0.5} wrap>
        <PlaceLevelInputs />
      </Grid>
    </>
  )
}

export default LevelsSection
